import { render, staticRenderFns } from "./test_detail.vue?vue&type=template&id=cebf4028&"
import script from "./test_detail.vue?vue&type=script&lang=js&"
export * from "./test_detail.vue?vue&type=script&lang=js&"
import style0 from "./test_detail.vue?vue&type=style&index=0&id=cebf4028&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports